export default "__VITE_ASSET__BZjv5M98__"